<script>
  import { onMount } from 'svelte';
  import { _, locale } from 'svelte-intl';
  import { config } from '../../stores';
  import { get } from '../../helpers/get';

  export let blockName = 'default';

  let bannerComponent;

  onMount(async () => {
    const banner = get(['BANNERS', blockName, $locale], $config);
    switch (banner) {
      case "discount":
        bannerComponent = (await import('./DiscountBanner/DiscountBanner.svelte')).default;
        break;
      case "x2":
        bannerComponent = (await import('./X2Banner/X2Banner.svelte')).default;
        break;
    }
  });
</script>

<style lang="stylus">
  h1
    font-size 20px
    font-weight bold
</style>

{#if !!bannerComponent}
<div class="banner-block">
  <h1>{$_('discounts')}</h1>
  <svelte:component this={bannerComponent} {...$$restProps} />
</div>
{/if}
